<template>
  <div class="personnel">
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column column is-full">
            <b-button v-if="(!is_template && currentUserAccess('PersonalDetails', this.UserActions.CREATE, this.project_id))
                            || (is_template && currentUserAccess('ProjectTemplates', this.UserActions.CREATE))" 
                      class="button is-primary" icon-left="plus-thick" @click="addNewPersonalClicked">
              {{ $t('personnel-view.new-personal-button') }}
            </b-button>
            <b-table class="personnel-table" :data="personnelData" :striped="true" :hoverable="false"
                     :mobile-cards="true" :loading="isLoading" :scrollable="true" >
              <b-table-column field="fullname" :label="this.$t('personnel-view.personal-fullname-column')" v-slot="props" sortable searchable>
                <router-link :to="{ name: 'PersonalDetails', params: { project_id:project_id, personal_id:props.row.personal.document_id, is_template: is_template }}">
                  {{ getAdjustedTitle(props.row.fullname) }}
                </router-link>                
              </b-table-column>
              <b-table-column field="personal.group" :label="this.$t('personnel-view.personal-group-column')" v-slot="props" sortable>
                {{
                  $t(personalGroupOptions.find(obj => {
                    return obj.id === props.row.personal.group
                  }).translationKey)
                }}
              </b-table-column>
              <b-table-column field="personal.agency" :label="this.$t('personnel-view.personal-agency-column')" v-slot="props" sortable searchable>
                {{ props.row.personal.agency }}
              </b-table-column>
              <b-table-column field="personal.category" :label="this.$t('personnel-view.personal-category-column')"
                              v-slot="props" sortable searchable>
                {{ props.row.personal.category }}
              </b-table-column>
            </b-table>
          </div>
        </div>
      </div>
      <b-modal
          :width="640"
          v-model="isPersonalDetailsModalActiveLocal"
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-modal>
        <template #default="props">
          <PersonalDetails v-bind:project_id="project_id" v-bind:personal_id="'new'" @close="props.close"
                           @personalAdded="readPersonnelData"></PersonalDetails>
        </template>
      </b-modal>
    </section>
  </div>
</template>

<script>
import PersonalDetails from "@/components/PersonalDetails";
import firebase from "firebase/app";

export default {
  name: "Personnel",
  components: {
    PersonalDetails
  },
  props: {
    'project_id': {
      type: String,
    },
    'is_template': {
      type: Boolean,
    }
  },
  data() {
    return {
      personnelData: [],
      isLoading: false,
      isPersonalDetailsModalActiveLocal: false
    }
  },
  methods: {
    readPersonnelData: function () {
      this.isPersonalDetailsModalActiveLocal = false;
      this.isLoading = true;
      this.personnelData = [];
      const functions = firebase.app().functions("europe-west3");
      const getPersonnelFunction = functions.httpsCallable(this.getSubmitEndpoint());
      console.log("project_id: ", this.project_id);
      getPersonnelFunction({action: "get_personnel", project_id: this.project_id, fill_meta: true})
          .then((result) => {
            console.log("personnel list result: ", result.data);
            if (result.data.personnel.length > 0) {
              result.data["personnel"].forEach((personal) => {
                this.personnelData.push({
                  personal: personal,
                  fullname: this.getFullName(personal.name),
                });
              });
            }
          })
          .catch((error) => {
            this.showError(error.message)
            console.log("Error getting personnel: ", error);
          });
      this.isLoading = false;
    },
    /*
     UI Events
     */
    addNewPersonalClicked: function () {
      this.isPersonalDetailsModalActiveLocal = true;
    },
  },
  mounted() {
    this.readPersonnelData();
  }
};
</script>

<style scoped>
.personnel-table {
  margin-top: 16px;
}
</style>
